import { Box, Icon, Link, Skeleton, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

import { useGetAllLeaveRequest } from 'services/api/modules/leave/leaveRequest'

import AdxTableBottomCTA from 'components/reusable/table/AdxTableBottomCTA'
import LeaveRequestCardList from '../components/leaveRequestCardList'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'
import AdxButton from 'components/custom/AdxButton'

const LeaveRequestCard = () => {
  const navigate = useNavigate()
  const { data: leaveRequests, isLoading } = useGetAllLeaveRequest({
    limit: 7,
    page: 1,
  })

  const ViewAllButton = () => {
    return (
      <AdxButton
        variant={'ghost'}
        onClick={() => navigate(`/app/leave/request/all`)}
        sx={{ width: 1 }}
      >
        View All
      </AdxButton>
    )
  }

  let array = new Array(5).fill('i')

  return (
    <>
      <Box
        sx={{
          backgroundColor: 'white.main',
          width: '100%',
          maxHeight: 'calc(100vh - 267px)',
          borderRadius: '4.5px',
          border: '1px solid #E5E5E5',
          overflow: 'auto',
        }}
        className="scrollbar"
      >
        {isLoading
          ? array?.map((arr, index) => (
              <Box key={index} p={2} sx={{ display: 'flex', width: '100%' }}>
                <Box width={3 / 4}>
                  <Skeleton height={35} width={'80%'} />
                </Box>
                <Box width={1 / 4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Skeleton height={35} width={'100%'} />
                </Box>
              </Box>
            ))
          : leaveRequests?.data?.map((item, index) => (
              <LeaveRequestCardList
                item={item}
                key={index}
                index={index}
                lastIndex={leaveRequests?.length - 1}
              />
            ))}

        <Box
          position={'sticky'}
          bottom={0}
          padding={1}
          bgcolor={'white.main'}
          sx={{ borderTop: '1px solid', borderColor: 'gray-line.main' }}
        >
          <ViewAllButton />
        </Box>
      </Box>
    </>
  )
}

export default LeaveRequestCard
